import cn from 'classnames'
import { useConfirm } from 'legacy/lut/components/shared/Confirm/useConfirm'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Switch } from 'core-components/library/checkbox'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { useAssortmentNotApplicable } from 'partner360/widgets/assortmentTab/hooks/useAssortmentNotApplicable'

import { applicableChangeConfirmDialogIdentifier } from '../../../applicableChangeConfirmDialog/ApplicableChangeConfirmDialog'

import { IAssortmentCategoryProps } from './models/IAssortmentCategoryProps'

import styles from './AssortmentCategory.module.scss'

export const AssortmentCategory: FC<IAssortmentCategoryProps> = ({
  isCollapsed = false,
  isSelected = false,
  partnerId,
  fYear,
  item,
  onClick,
}) => {
  const { confirm } = useConfirm()
  const handleApplicableChange = useAssortmentNotApplicable({
    partnerId,
    fYear,
    category: item,
  })
  const isPublishingMode = useSelector(selectPublishingMode)

  const isCompleted = useMemo(() => {
    return item.Status === 'Completed'
  }, [item])

  const isNotCompleted = useMemo(() => {
    return item.Status === 'Not Completed'
  }, [item])

  const handleClickAssortment = useCallback(() => {
    onClick(item)
  }, [onClick, item])

  return (
    <div
      className={cn(styles.root, [
        {
          [styles.selected]: isSelected,
        },
      ])}
    >
      <div className={styles.content} onClick={handleClickAssortment}>
        <RenderWhen condition={isPublishingMode}>
          <Switch
            checked={item.IsApplicable === 1}
            onChange={async (newState) => {
              let canChange = true
              if (!newState) {
                const isConfirmed = await confirm(applicableChangeConfirmDialogIdentifier)
                if (!isConfirmed) {
                  canChange = false
                }
              }

              if (canChange) {
                handleApplicableChange({
                  isNotApplicable: newState,
                  categoryField: item.Title,
                })
              }
            }}
            size={'sm'}
          />
        </RenderWhen>
        <div className={styles.title}>
          <Translation span text={isCollapsed ? `${item.Title}--short` : item.Title} />
        </div>
        <RenderWhen condition={item.IsApplicable === 1}>
          <RenderWhen condition={!isCollapsed}>
            <i
              className={cn('kbase', styles.icon, {
                [styles.completed]: isCompleted,
                [styles.notCompleted]: isNotCompleted,
                'kbase-check-circle-alt': isCompleted,
                'kbase-lvl-clock-alt': isNotCompleted,
              })}
            />
          </RenderWhen>
          <RenderWhen condition={isCollapsed}>
            <i
              className={cn('kbase', styles.iconMinified, {
                [styles.completed]: isCompleted,
                [styles.notCompleted]: isNotCompleted,
              })}
            />
          </RenderWhen>
        </RenderWhen>
        <RenderWhen condition={item.IsApplicable === 0}>
          <RenderWhen condition={!isCollapsed}>
            <div className={cn(styles.notApplicableIcon)}>N/A</div>
          </RenderWhen>
          <RenderWhen condition={isCollapsed}>
            <div className={cn(styles.notApplicableIconMinified)} />
          </RenderWhen>
        </RenderWhen>
      </div>
    </div>
  )
}
